/* eslint-disable @typescript-eslint/no-explicit-any */
const getSocialUrl = (prefix: any, id: any) => {
  if (id) {
    const strippedId = id.replace(/https?:\/\/(www.)?([a-z]+)?(\.com)?\/?/, '');
    return prefix + strippedId;
  }

  return null;
};

export default getSocialUrl;
